import React from "react";

const CopyRight = () => {
  const currentYear = new Date().getFullYear();
  return <p>&copy; {currentYear} go2greece</p>;
};
export default CopyRight;
